import React, { useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import SEO from '../seo/SEO';
import './blogPost.css';
import { getBlogPostBySlug } from '../../data/blogData';

const BlogPost = () => {
  const { slug } = useParams();
  const post = getBlogPostBySlug(slug);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  if (!post) {
    return (
      <>
        <SEO 
          title="Blog Post Not Found | Niks Elite Cleaning"
          description="The blog post you're looking for could not be found."
        />
        <div className="blog-post-container">
          <div className="container">
            <div className="post-not-found">
              <h1>Blog Post Not Found</h1>
              <p>Sorry, the blog post you're looking for doesn't exist.</p>
              <Link to="/#blog" className="btn">Back to Blog</Link>
            </div>
          </div>
        </div>
      </>
    );
  }

  return (
    <>
      <SEO 
        title={`${post.title} | Niks Elite Cleaning Blog`}
        description={post.metaDescription || post.excerpt}
      />
      <div className="blog-post-container">
      <div className="blog-post-hero" style={{ backgroundImage: `url(${post.image})` }}>
        <div className="hero-overlay"></div>
        <div className="container">
          <div className="hero-content" data-aos="fade-up">
            <div className="post-category">{post.category}</div>
            <h1>{post.title}</h1>
            <div className="post-meta">
              <span><i className="far fa-calendar"></i> {new Date(post.date).toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' })}</span>
              <span><i className="far fa-user"></i> {post.author}</span>
            </div>
          </div>
        </div>
      </div>

      <div className="blog-post-content">
        <div className="container">
          <article className="post-article" data-aos="fade-up" data-aos-delay="200">
            <div dangerouslySetInnerHTML={{ __html: post.content }} />
          </article>

          <div className="post-footer" data-aos="fade-up" data-aos-delay="300">
            <div className="cta-box">
              <h3>Need Professional Cleaning Services?</h3>
              <p>Contact Niks Elite Cleaning today for a free quote. Serving Melbourne's western suburbs with excellence.</p>
              <div className="cta-buttons">
                <a href="tel:+61493519401" className="btn btn-primary">
                  <i className="fas fa-phone"></i> Call Now
                </a>
                <Link to="/#contact" className="btn btn-secondary">
                  Get a Quote
                </Link>
              </div>
            </div>
            
            <Link to="/#blog" className="back-to-blog">
              <i className="fas fa-arrow-left"></i> Back to All Posts
            </Link>
          </div>
        </div>
      </div>
    </div>
    </>
  );
};

export default BlogPost;
